// extracted by mini-css-extract-plugin
export default {"fleetManagementTable":"conventional-pcr-frontend-fleet-management-fleet-management-table-styles-fleet-management-table-module__fleetManagementTable--4VoyluZVZx3aZ55M6RdlLg=="};